<template>
<div class="chapter">
<div class="inner_page">
<div class="copy">
<p><br/><br/><br/><br/><br/><br/></p>
<p class="copy">Published by arrangement with McClelland &amp; Stewart Ltd, Toronto, Canada</p>
<p class="copy">Copyright © 2010 by Martin Gilbert</p>
<p class="copy">All rights reserved. This book may not be reproduced in whole or in part, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press), without written permission from the publishers.</p>
<p class="copy">For more information about this and other Yale University Press publications, please contact:<br/>U.S. Office: <a href="mailto://sales.press@yale.edu" target="_blank">sales.press@yale.edu</a>    <a href="http://www.yalebooks.com" target="_blank">www.yalebooks.com</a><br/>Europe Office: <a href="mailto://sales@yale.co.uk" target="_blank">sales@yale.co.uk</a>      <a href="http://www.yalebooks.co.uk" target="_blank">www.yalebooks.co.uk</a></p>
<p class="copy">Typeset in New Baskerville by M&amp;S, Toronto<br/>Printed in Great Britain by TJ International Ltd, Padstow, Cornwall</p>
<p class="copy">Library and Archives Canada Cataloguing in Publication</p>
<p class="copy">Gilbert, Martin, 1936 <br/>
    Jews under Muslim rule: a 1,400–year history/Martin Gilbert.<br/>
    ISBN 978–0–7710–3369–8<br/>
    1. Jews–Islamic Empire–History. 2. Jews–Islamic countries–History<br/>
    3. Judaism–Relations–Islam–History.<br/>
    4. Islam–Relations–Judaism–History. I. Title.<br/>
    BP173 J8G54 2010    296.3′97    C2009–906537–1</p>
<p class="copy">ISBN 978–0–300–16715–3</p>
<p class="copy">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?2b30781e